/**
 * @see https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/transition/src/transition-utils.ts#L116
 */
export const MODAL_MOTION_SCALE_EXIT_DURATION = 100;
